import React from "react";
import ImageSlider from "./ImageSlider";
import "./header.css";

export default function TopHeader() {
  return (
    <div className="h-screen flex items-center justify-center">
      <div className="flex justify-between">
        <div className="w-1/2 p-0 flex flex-col justify-center">
          <div className="text-6xl font-bold compass_color">Discover</div>
          <div className="text-3xl compass_color">
            Get updates about LUAA and other members
          </div>
        </div>
        <div className="">
          <div className="p-10 w-96 h-96 bg-whit rounded-full border- border-green flex justify-center items-center slide_car">
            <ImageSlider />
          </div>
        </div>
      </div>
    </div>
  );
}
